export class AACFileInfo {
    businessUnitId: string;
    fileName: string;
    filePath: string;
    fileTranscription: string;
    insUser: string;
    voiceId: any;
    fileId: string;

    constructor(jsonData?)
    {
        if (jsonData) {
            this.businessUnitId = jsonData.businessUnitId;
            this.fileName = jsonData.fileName;
            this.filePath = jsonData.filePath;
            this.fileTranscription = jsonData.fileTranscription;
            this.insUser = jsonData.insUser;
            this.voiceId = jsonData.voiceId;
            this.fileId = jsonData.id;
        }
        else {
            this.businessUnitId = '';
            this.fileName = '';
            this.filePath = '';
            this.fileTranscription = '';
            this.insUser = '';
            this.voiceId = '';
            this.fileId = '';
        }
    }
}
